// Centralized Supabase Real-time Subscription Manager
import { supabase } from '../lib/supabase';

export type SubscriptionConfig = {
  channel: string;
  event: '*' | 'INSERT' | 'UPDATE' | 'DELETE';
  schema: string;
  table: string;
  filter?: string;
  callback: (payload: any) => void;
};

export class SupabaseRealtimeManager {
  private channels: Record<string, ReturnType<typeof supabase.channel>> = {};

  subscribe(config: SubscriptionConfig) {
    const key = `${config.channel}-${config.table}-${config.event}`;
    if (this.channels[key]) {
      // Already subscribed
      return;
    }
    const channel = supabase.channel(config.channel)
      .on(
        'postgres_changes' as any,
        {
          event: config.event,
          schema: config.schema,
          table: config.table,
          ...(config.filter ? { filter: config.filter } : {})
        },
        config.callback
      )
      .subscribe();
    this.channels[key] = channel;
  }

  unsubscribe(channel: string) {
    Object.keys(this.channels)
      .filter(key => key.startsWith(channel))
      .forEach(key => {
        this.channels[key].unsubscribe();
        delete this.channels[key];
      });
  }

  unsubscribeAll() {
    Object.values(this.channels).forEach(channel => channel.unsubscribe());
    this.channels = {};
  }
}

export const supabaseRealtimeManager = new SupabaseRealtimeManager();
